import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTicket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTicket"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V9.92703L21.3714 10.1785C19.7095 10.8432 19.7095 13.1568 21.3714 13.8215L22 14.073V20H2V14.073L2.62861 13.8215C4.29046 13.1568 4.29046 10.8432 2.62861 10.1785L2 9.92703V4ZM16 7V9H14V7H16ZM16 11V13H14V11H16ZM16 15V17H14V15H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTicket;
